import { render, staticRenderFns } from "./Vistas.vue?vue&type=template&id=06ab8361"
import script from "./Vistas.vue?vue&type=script&lang=js"
export * from "./Vistas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports